import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['chart', 'display'],
  watch: {
    chart: function () {
      this.renderChart({
        labels: this.chart.labels,
        datasets: this.chart.datasets,
      }, this.options)
    }
  },
  computed: {
    chartData: function () {
      return this.chart;
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatios: false,
        legend: {
          display: this.display
        },
        scales: {
          'left-y-axis': {
            type: 'linear',
            position: 'left'
          },
          'right-y-axis': {
            type: 'linear',
            position: 'right'
          },
          xAxes: [{
            ticks: {
              callback: (value, index, values) => {
                return value;
              },
            },
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'kWh'
            },
            name: "2",
            display: true,
            position: "left",
            id: "y-axis-1",
            ticks: {
              suggestedMin: 0,    // minimum will be 0, unless there is a lower value.
              stepSize: 50,  
            }
          }, {
            type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
            display: true,
            position: "right",
            id: "y-axis-2",
            // grid line settings
            gridLines: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
          }
          ]
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: ((tooltipItems, data) => {
              return tooltipItems.yLabel + ' ' + data.datasets[tooltipItems.datasetIndex].label;
            })
          }
        }
      }
    }
  },
  mounted() {
    this.renderChart({
      labels: this.chart.labels,
      datasets: this.chart.datasets,
    }, this.options)
  }
}